import {observable, action, runInAction} from 'mobx'
import {json} from '../../../utils/ajax'
import {handleSearchAndPage, setStore, ValueObjToObj} from "../../../utils/Utils";
import moment from 'moment'

class UserOperationRecordStore {

    @observable loading         //后台操作记录列表数据loading
    @observable userOperationRecordList  //后台操作记录列表数据
    @observable pagination      //分页
    @observable searchField //表单搜索值

    constructor() {
        this.loading = false
        this.userOperationRecordList = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchField = {
            account: '',
            model: '',
            type: '',
            description: '',
            startTime: '',
            endTime: '',
            rangePicker:[]
        }
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**初始化页面*yg**/
    @action
    initUserOperationRecordPage = async (page) => {
        this.loading = true
        let searchField = {
            ...this.searchField,
            model: this.searchField.model ? this.searchField.model:'',
            type:this.searchField.type ? this.searchField.type :'',
            startTime: this.searchField.rangePicker.length > 0 ? moment(this.searchField.rangePicker[0]).format("YYYY-MM-DD") : '',
            endTime: this.searchField.rangePicker.length > 0 ? moment(this.searchField.rangePicker[1]).format("YYYY-MM-DD") : ''
        };
        let searchResult = handleSearchAndPage(page, this.pagination, searchField)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/userOperationRecord/page:search`, searchResult)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.userOperationRecordList = res.content ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements?res.totalElements:0} 条`
            }
            this.loading = false
        })
    }

    /***搜索表单绑值**/
    @action
    onSearchField = (changedFields) => {
        this.searchField = {...this.searchField, ...ValueObjToObj(changedFields)}
    }

    /***重置**/
    @action
    handleReset=()=>{
        this.searchField = {
            account: '',
            model: '',
            type: '',
            description: '',
            startTime: '',
            endTime: '',
            rangePicker:[]
        }
        this.initUserOperationRecordPage()
    }

}

export default new UserOperationRecordStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/UserOperationRecord/store.js